//工作台待处理
export default {
  state: {
    untreated: false,
    lessee:'',
    flag:true,
  },
  mutations: {
    GET_UNTREATED(state, untreated) {
      state.untreated = untreated
    },
    GET_LESSEE(state, lessee) {
      state.lessee = lessee
    },
    GET_FLAG(state, flag) {
      state.flag = flag
    }
  },
  actions: {},
}
